import { defineMessages, useIntl } from 'react-intl';

import {
  ContentImage,
  EventoCosE,
  EventoLuoghi,
  EventoDateOrari,
  EventoCosti,
  EventoDocumenti,
  EventoPadreEFigli,
  EventoUlterioriInformazioni,
  EventoSponsors,
  BandoText,
  BandoUfficioResponsabile,
  BandoAreaResponsabile,
  BandoServizi,
  BandoDate,
  BandoApprofondimenti,
  BandoUlterioriInformazioni,
  ServizioCosE,
  ServizioAccedi,
  ServizioAChiSiRivolge,
  ServizioComeFare,
  ServizioCosaServe,
  ServizioCosaSiOttiene,
  ServizioCostiVincoli,
  //ServizioTempiScadenze,
  ServizioCasiParticolari,
  ServizioProcedure,
  ServizioContatti,
  ServizioAltriDocumenti,
  ServizioSitiEsterni,
  ServizioAllegati,
  ServizioModulistica,
  ServizioTrasparenza,
  ServizioCorrelati,
  ServizioUlterioriInformazioni,
  ServizioMetadati,
  ServizioCondizioni,
  ServizioArgomenti,
  ServizioMetatag,
  ServizioTempiScadenze,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import PageView from 'design-comuni-plone-theme/components/ItaliaTheme/View/PageView/PageView';

import SideMenuByTitles from 'design-comuni-plone-theme/components/ItaliaTheme/View/Commons/SideMenuByTitles';

import EventoContatti from 'volto-io-comune-v2/components/ItaliaTheme/View/EventoView/EventoContatti';

import EventoGallery from 'rer-theme/components/View/EventoView/EventoGallery';
import BandoUpdateNote from 'rer-theme/components/View/BandoView/BandoUpdateNote';
import BandoMaterie from 'rer-theme/components/View/BandoView/BandoMaterie';
import BandoRiferimenti from 'rer-theme/components/View/BandoView/BandoRiferimenti';

import PubblicazioneView from 'rer-theme/components/View/PubblicazioneView/PubblicazioneView';
import RawHtmlView from 'rer-theme/components/View/RawHtmlView/RawHtmlView';

import CartellaApprofondimentoView from 'rer-theme/components/View/CartellaApprofondimento/CartellaApprofondimentoView';

const messages = defineMessages({
  index: {
    id: 'index_rer',
    defaultMessage: 'Indice',
  },
});

const RERSideMenu = ({ data, content_uid }) => {
  const intl = useIntl();
  return SideMenuByTitles({
    data: data,
    content_uid: content_uid,
    index_title: intl.formatMessage(messages.index),
  });
};

const getRerViews = (config) => {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    'Bando Folder Deepening': CartellaApprofondimentoView,
    Foglia: PageView,
    Pubblicazione: PubblicazioneView,
    RawHtml: RawHtmlView,
    Redazione: PageView,
  };

  config.settings.italiaThemeViewsConfig = {
    ...(config.settings.italiaThemeViewsConfig ?? {}),
    'News Item': {
      ...(config.settings.italiaThemeViewsConfig['News Item'] ?? {}),
      updateSideMenuOnLoadingBlocks: true,
      sideMenu: RERSideMenu,
    },
    Event: {
      ...(config.settings.italiaThemeViewsConfig['Event'] ?? {}),
      updateSideMenuOnLoadingBlocks: true,
      sideMenu: RERSideMenu,
      sections: [
        {
          /* HEADER IMAGE */
          component: ContentImage,
          props: { position: 'documentBody' },
        },
        { /* COS'è */ component: EventoCosE },
        { /* LUOGHI */ component: EventoLuoghi },
        { /* DATE E ORARI */ component: EventoDateOrari },
        { /* COSTI */ component: EventoCosti },
        { /* DOCUMENTI */ component: EventoDocumenti },
        { /* GALLERY !RER! */ component: EventoGallery },
        { /* CONTATTI */ component: EventoContatti },
        { /* EVENTS */ component: EventoPadreEFigli },
        { /* SPONSORS */ component: EventoSponsors },
        { /* ULTERIORI INFORMAZIONI */ component: EventoUlterioriInformazioni },
      ],
    },
    Venue: {
      ...(config.settings.italiaThemeViewsConfig['Venue'] ?? {}),
      updateSideMenuOnLoadingBlocks: true,
      sideMenu: RERSideMenu,
    },
    Bando: {
      ...(config.settings.italiaThemeViewsConfig['Bando'] ?? {}),
      updateSideMenuOnLoadingBlocks: true,
      sideMenu: RERSideMenu,
      sections: [
        { /* Testo */ component: BandoText },
        /* Responsabili */
        { /* UFFICIO */ component: BandoUfficioResponsabile },
        { /* AREA */ component: BandoAreaResponsabile },
        { /* SERVIZI */ component: BandoServizi },
        { /* DATE IMPORTANTI  */ component: BandoDate },
        {
          /* ALLEGATI (CARTELLE APPROFONDIMENTI)  */ component:
            BandoApprofondimenti,
        },
        { /* RIFERIMENTI rer  */ component: BandoRiferimenti },
        { /* MATERIE rer  */ component: BandoMaterie },
        { /* ULTERIORI INFORMAZIONI  */ component: BandoUlterioriInformazioni },
        { /* UPDATE NOTE rer */ component: BandoUpdateNote },
      ],
    },
    Servizio: {
      ...(config.settings.italiaThemeViewsConfig['Servizio'] ?? {}),
      updateSideMenuOnLoadingBlocks: true,
      sideMenu: RERSideMenu,
      sections: [
        {
          /* HEADER IMAGE */

          component: ContentImage,
          props: { position: 'documentBody' },
        },

        { /* METADATI SCHEMA.ORG */ component: ServizioMetatag },
        { /* DESCRIZIONE */ component: ServizioCosE },
        { /* A CHI È RIVOLTO */ component: ServizioAChiSiRivolge },

        { /* COME FARE */ component: ServizioComeFare },

        { /* COSA SERVE */ component: ServizioCosaServe },

        { /* COSA SI OTTIENE */ component: ServizioCosaSiOttiene },

        // { //rimosso, alla rer non serve
        //   /* TEMPI E SCADENZE */
        //   component: ServizioTempiScadenze,
        // },

        { /* QUANTO COSTA */ component: ServizioCostiVincoli },

        { /* CASI PARTICOLARI */ component: ServizioCasiParticolari },

        { /* PROCEDURE ESITO */ component: ServizioProcedure },

        { /* ACCEDI AL SERVIZIO */ component: ServizioAccedi },

        {
          /* ULTERIORI INFORMAZIONI */ component: ServizioUlterioriInformazioni,
        },

        { /* ALTRI DOCUMENTI */ component: ServizioAltriDocumenti },

        { /* SITI ESTERNI */ component: ServizioSitiEsterni },

        { /* ALLEGATI */ component: ServizioAllegati },

        { /* MODULISTICA */ component: ServizioModulistica },

        { /* CONDIZIONI DI SERVIZIO */ component: ServizioCondizioni },

        { /* CONTATTI */ component: ServizioContatti },

        { /* TRASPARENZA */ component: ServizioTrasparenza },

        { /* CORRELATI  */ component: ServizioCorrelati },

        { /* ARGOMENTI */ component: ServizioArgomenti },

        { /* ULTIMO AGGIORNAMENTO  */ component: ServizioMetadati },
      ],
    },
  };
};

export default getRerViews;
